import { useRef, useState, useEffect } from 'react';
import { SearchOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Input, Space, Table, Modal, Form, Select,Popconfirm,message,TreeSelect } from 'antd';
import Highlighter from 'react-highlight-words';
import { useLocation,useNavigate } from 'react-router-dom';
import axios from 'axios';



const Users = () => {
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [open, setOpen] = useState(false);
  const [departmentValue, setDepartmentValue] = useState('');
  const [roleValue, setRoleValue] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [form] = Form.useForm();
  const [recordId, setRecordId] = useState(null);
  const [error,setError] = useState();
  const [treeVisibleData, setTreeVisibleData] = useState([]);
  const searchInput = useRef(null);
    const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const navigate = useNavigate();

  // useEffect(() => {
  //   const userString = sessionStorage.getItem("user");
  //   const value = JSON.parse(userString)
  //   if (!userString) {
  //     navigate('/login')
  //   }

  // }, [])


  useEffect(() => {
    fetchMenuData();
    getTreeVisible();
    const paramValue = searchParams.get('add');
    paramValue ? setOpen(true) : setOpen(false);
  }, []);

  const fetchMenuData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/users`)
      .then(response => {
        const modifiedResponse = response.data.map(item => ({
          ...item,
          key: item.id,
        }));

        // console.log('modifiedResponse',modifiedResponse)
        setData(modifiedResponse);
      })
      .catch(error => {
        console.error(error);
      });
  };
  const getTreeVisible = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/departments_tree`);
      // console.log('ress',response.data)
      const filteredResponse = response.data.map(item => ({
        ...item,
        children: item.children.filter(child => child.title === "aall")
    }));
      setTreeVisibleData(filteredResponse)
   
    } catch (error) {
      console.log(error);
    }
  };

  

  const onFinish = values => {
    // console.log('usersForm value',values)
   
    values.role = roleValue ? roleValue : selectedRowData.role;

    if (isEdit) {
      
      // Update existing menu item
      axios
        .patch(`${process.env.REACT_APP_API_URL}/users/${selectedItemId}`, values)
        .then(response => {
          // console.log(response.data);
          fetchMenuData(); // Refresh the data after successful update
          message.success('Edited Successfully!');
        })
        .catch(error => {
        console.error(error.response.data.msg);
        // message.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function() {
          setError();
        }, 3000);
      });
    } else {
      // Create new menu item
      axios
        .post(`${process.env.REACT_APP_API_URL}/users`, values)
        .then(response => {
          // console.log(response.data);
          fetchMenuData(); // Refresh the data after successful creation
          message.success('User Created Successfully!');
        })
        .catch(error => {
        console.error(error.response.data.msg);
        // message.error(error.response.data.msg);
        setError(error.response.data.msg);
        setTimeout(function() {
          setError();
        }, 3000);
      });
    }
  
    handleCancel();
  };
  

  const onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
  };

  const onChange = checked => {
    setLoading(!checked);
  };

  
  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
    }, 3000);
  };

  const handleCancel = () => {
    form.resetFields();
    setSelectedItemId(null);
    setSelectedRowData(null)
    setOpen(false);
  };

  const paginationConfig = {
    pageSize: 6,
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = clearFilters => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={e => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys, confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button type="link" size="small" onClick={() => close()}>
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: visible => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: text =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: '5%',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: '15%',
      ...getColumnSearchProps('name'),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      width: '10%',
      ...getColumnSearchProps('email'),
    },
    {
      title: 'Department',
      dataIndex: 'department',
      key: 'department',
      width: '10%',
      ...getColumnSearchProps('department'),
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      width: '10%',
      ...getColumnSearchProps('role'),
    },
    {
      title: 'Action',
      dataIndex: 'action',
      width: '20%',
      key: 'action',
      ...getColumnSearchProps('action'),
      sorter: (a, b) => a.action.length - b.action.length,
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          >
            Edit
          </Button>
           <Popconfirm
            title="Are you sure you want to delete this department/sub-department?"
            onConfirm={() => handleDelete(record)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="danger" icon={<DeleteOutlined />}>
              Delete
            </Button>
          </Popconfirm>
        </span>
      ),
    },
  ];
  

 
  

  const handleDelete = record => {
    axios.delete(`${process.env.REACT_APP_API_URL}/users/${record.uuid}`)
      .then(response => {
        // console.log(response.data);
        fetchMenuData(); // Refresh the data after successful deletion
        message.success('Deleted Successfully!');
      })
      .catch(error => {
        console.error(error);
      });
  };

 
  //// Onchange for Icon type selection

  const handleChange = (value) => {
    console.log(`selected ${value}`);
    setDepartmentValue(value)
  };

  //// Onchange for menu type selection

  const handleChangeType = (value) => {
    console.log(`selected ${value}`);
    setRoleValue(value)
  };

  const showModal = () => {
    form.resetFields();
    setIsEdit(false);
    setSelectedRowData(null)
    setSelectedItemId(null);
    form.setFieldsValue({
      name: null,
      email: null,
      department: null,
      role: null
    });
    
    setOpen(true);
     // Clear the selected item ID
  };

  const handleEdit = record => {

    // console.log('record',record);

    form.resetFields();
    setIsEdit(true);
    setSelectedItemId(record.uuid);
    setRecordId(record.uuid);
    setSelectedRowData(record);
     const departmentValue = Array.isArray(record.department) ? record.department : [record.department];

     const filteredTreeData = treeVisibleData.filter(item => departmentValue.includes(item.title));
     const newDefault = [ {
      title: "",
      value: "2c47165f-a9e1-4a69-84a8-1d0c79hfb5edb5",
     
  
  },...filteredTreeData]
 
    // console.log('departmentValue',filteredTreeData)
    form.setFieldsValue({
      name: record.name,
      email: record.email,
      department: newDefault,
      role: record.role,
      password:record.password,
      confPassword:record.password
    });
    setOpen(true);

  };

  return (
    <div className="depSubDept">
       {error && <div className='errorApi'>{error}</div>}
      <div>
        <div className="tableTitle">
          <h3>All Users</h3>
          <Button type="primary" name='addItem' onClick={showModal}>
            Add User
          </Button>
        </div>
        <Table columns={columns} dataSource={data} />
      </div>

      <Modal
      open={open}
      title="Add User"
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Return
        </Button>,
        <Button key="submit" type="primary" loading={loading} htmlType="submit" form="userForm">
          Submit
        </Button>
      ]}
    >
      <Form
        name="basic"
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        style={{
          maxWidth: 600,
        }}
        
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        id="userForm" // Add an ID to the form
        layout=''
      >
        <Form.Item
          label="User Name"
          name="name"
          rules={[
            {
              required: true,
              message: 'Please input user name!',
            },
          ]}
        >
          <Input type='text'  placeholder="Please input username"
                    allowClear />
        </Form.Item>

        <Form.Item
          label="User Password"
          name="password"
          rules={[
            {
              required: true,
              message: 'Please input user password!',
            },
          ]}
        >
          <Input type='password'  placeholder="Please input user password"
                    allowClear/>
        </Form.Item>

        <Form.Item
          label="Confirm Password"
          name="confPassword"
          rules={[
            {
              required: true,
              message: 'Please input confirm password!',
            },
          ]}
        >
          <Input type='password'  placeholder="Please input confirm password"
                    allowClear/>
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              message: 'Please input email!',
            },
          ]}
        >
          <Input type='email'  placeholder="Please input user email"
                    allowClear/>
        </Form.Item>


        <Form.Item
                  label='Department'
                  name='department'
                  rules={[{ required: true, message: 'Please select Department/subDepartment' }]}
                >
                 
                  <TreeSelect
                    showSearch
                    style={{
                      width: '100%',
                    }}
                    dropdownStyle={{
                      maxHeight: 400,
                      overflow: 'auto',
                    }}
                    placeholder="Please select Department/subDepartment"
                    allowClear
                    multiple
                    treeNodeFilterProp="title"
                    treeData={treeVisibleData}
                  />
                </Form.Item>

        <Form.Item
          label="User Role"
          name="role"
          rules={[
            {
              required: true,
              message: 'Please select a role!',
            },
          ]}
        >
          <Select
            onChange={handleChangeType}
            allowClear
            placeholder="Please select role for user"
            options={[
            {
                value: 'user',
                label: 'User',
              }
            ]}
          />

        </Form.Item>

      </Form>
    </Modal>
    </div>
  );
};

export default Users;
